import useEmblaCarousel from 'embla-carousel-react';
import { Videostrip } from 'types/studio/studio';
import { ChevronLeftIcon, ChevronRightIcon } from '@ag1/ui';

import clsx from 'clsx';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import VideostripItem from '../VideostripItem/VideostripItem';
import styles from './VideostripSlider.module.scss';

type Props = {
  onItemClick: (index: number) => void;
  visibleOnPageLoad: boolean;
} & Pick<Videostrip, 'items' | 'showSliderButtons' | 'theme'>;

const VideostripSlider = (props: Props) => {
  const { onItemClick, showSliderButtons, items, theme, visibleOnPageLoad } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: 'start',
    containScroll: 'trimSnaps'
  });

  return (
    <div className={styles.root}>
      <div className={styles.slider} ref={emblaRef}>
        <div className={styles.list}>
          {items.map((item, index) => (
            <div className={styles.item} key={item._key}>
              <VideostripItem
                theme={theme}
                onClick={() => onItemClick(index)}
                item={item}
                imageSizes={{ xxs: '241px', s: '326px', m: '414px', xl: '456px' }}
                eagerLoading={visibleOnPageLoad && index < 3}
              />
            </div>
          ))}
        </div>
      </div>
      {showSliderButtons && (
        <div className={styles.navigation}>
          <button
            type="button"
            className={clsx(styles.navButton, getThemeCSSClass(theme))}
            onClick={() => emblaApi?.scrollPrev()}>
            <ChevronLeftIcon titleAccess="Previous" />
          </button>
          <button
            type="button"
            className={clsx(styles.navButton, getThemeCSSClass(theme))}
            onClick={() => emblaApi?.scrollNext()}>
            <ChevronRightIcon titleAccess="Next" />
          </button>
        </div>
      )}
    </div>
  );
};

export default VideostripSlider;
